<template>
    <base-page
      v-bind:schemaName="'message'"
      v-bind:isHideSave="true"
      v-bind:isHideRemove="true"
          v-model:entity="entity"
    >
        <template v-slot:panel-left="{ entity }">
            <div class="mb-3 text-left">
                <label class="form-label">{{ $filters.localize('main.createdOn') }}</label>
                <input
                  :disabled="true"
                  type="text"
                  class="form-control"
                  v-model="entity.createdOn"
                >
            </div>
            <div class="mb-3 text-left">
                <label class="form-label">Контакт</label>
                <label class="form-control">{{ entity.contact?.fullName }}</label>
            </div>
            <div class="mb-3 text-left">
                <label class="form-label">Ідентифікатор</label>
                <input
                  :disabled="true"
                  type="text"
                  class="form-control"
                  v-model="entity.identifier"
                >
            </div>
        </template>
        <template v-slot:body="{ entity }">
            <div class="mb-3 text-left message-page__message-field">
                <label class="form-label">{{ $filters.localize('MessageDetail.caption') }}</label>
                <textarea
                  :disabled="true"
                  type="text"
                  class="form-control message-page__message-control"
                  v-model="entity.text"
                ></textarea>
            </div>
        </template>
    </base-page>
</template>

<script>
import BasePage from '@/components/Sections/BasePage.vue';
export default {
    name: "MessagePage",
    components: { BasePage },
    data() {
    return {
      entity: {},
    };
  },
}
</script>
<style scoped>
.message-page__message-field {
    margin-bottom: 0 !important;
}

.message-page__message-field .form-label {
    margin-bottom: 3px;
    color: #526171;
    font-size: 0.74rem;
    font-weight: 700;
    line-height: 1.15;
}

.message-page__message-control {
    min-height: min(420px, calc(100vh - 170px));
    height: calc(100vh - 170px);
    padding: 4px 8px;
    color: #495057;
    font-size: 0.84rem;
    line-height: 1.2;
    resize: vertical;
}

@media (max-width: 767.98px) {
    .message-page__message-control {
        min-height: 260px;
        height: 50vh;
    }
}
</style>
